import * as UserModule from 'Modules/UserModule';
import * as AuthModule from 'Modules/AuthModule';
import { User } from '../EnumTypes/ActionEnumTypes';
import { toast } from 'react-toastify';

export const success = (data) => ({
  type: User.CHANGE_USER_NAME_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: User.CHANGE_USER_NAME_FAILURE,
});

const changeUserName = (name: string) => async (dispatch) => {
  const id = toast.loading('Trwa zmiana nazwy...');
  try {
    const response = await UserModule.Connector.changeUserName(name);
    toast.update(id, {
      render: 'Nazwa została zmieniona',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
    });
    dispatch(AuthModule.Actions.getAuthorizedUser());
    dispatch(success(response.data.user));
    return true;
  } catch (err) {
    toast.update(id, {
      render: 'Nie udało się zmienić nazwy',
      type: toast.TYPE.ERROR,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
    });
    dispatch(failure());
    return false;
  }
};

export default changeUserName;
